import React from "react";
import "./App.css";
import { trackEvent } from "./analytics";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "./landingpage";
import Brochure from "./Brochure";
import BlogList from "./blog/BlogList";
import BlogPostSerious from "./blog/BlogPostSerious";
import BlogPostSafetyManager from "./blog/BlogPostSafetyManager";
import BlogPostRiskAssessment from "./blog/BlogPostRiskAssessment";
import BlogPostTBM from "./blog/BlogPostTBM";
import BlogPostDailyRecord from "./blog/BlogPostDailyRecord";
import BlogPostExecutiveRisk from "./blog/BlogPostExecutiveRisk";
import BlogPostExemption from "./blog/BlogPostExemption";
import BlogPostRainySeason from "./blog/BlogPostRainySeason";

// 사이트 공통 플로팅 상담 버튼. 브로슈어 페이지는 자체 하단 바(전화 · PDF · 문의)를 가지므로 제외한다.
function FloatingContact() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/brochure")) return null;
  return (
    <nav className="contact_actions" aria-label="빠른 상담">
      <a className="contact_phone" href="tel:0232722302" onClick={() => trackEvent("phone_click", { location: "floating", page: window.location.pathname })}>
        <span>전화 상담</span>
        <strong>02-3272-2302</strong>
      </a>
      <a className="contact_trial" href="/#contact" onClick={() => trackEvent("trial_cta_click", { location: "floating", page: window.location.pathname })}>무료체험 문의</a>
    </nav>
  );
}

class App extends React.Component {
  render() {
    return (
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/brochure" element={<Brochure />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/serious-accident-law" element={<BlogPostSerious />} />
          <Route path="/blog/safety-manager-paperwork" element={<BlogPostSafetyManager />} />
          <Route path="/blog/risk-assessment-5steps" element={<BlogPostRiskAssessment />} />
          <Route path="/blog/tbm-no-record" element={<BlogPostTBM />} />
          <Route path="/blog/daily-record-3things" element={<BlogPostDailyRecord />} />
          <Route path="/blog/executive-punishment-conditions" element={<BlogPostExecutiveRisk />} />
          <Route path="/blog/exemption-one-difference" element={<BlogPostExemption />} />
          <Route path="/blog/rainy-season-safety" element={<BlogPostRainySeason />} />
        </Routes>
        <FloatingContact />
      </BrowserRouter>
    );
  }
}

export default App;
